export default __webpack_public_path__ + "assets/images/db280003f73a22ddd7d2be57b2446958.png";